import { useTranslation } from 'react-i18next';
import { FormControl } from '@material-ui/core';
import { FieldArray } from 'redux-form';
import { requiredArray } from '../../../util/validators';
import React from 'react';
import { DynamicComponentInput, DynamicFormFieldArray, renderDynamicComponent } from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { stocksInitialValue } from '../../../util/initial-values';

const stockInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.financialStatementSecurityName,
    isOptional : false,
    label      : 'Name of Security',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName  : FieldNames.financialStatementNumOfShares,
    isOptional : false,
    label      : 'Number of Shares',
    type       : DynamicFormFieldArrayType.INTEGER_ALLOW_ZERO,
  },
  {
    fieldName  : FieldNames.financialStatementMarketValue,
    isOptional : false,
    label      : 'Market Value',
    type       : DynamicFormFieldArrayType.CURRENCY,
  },
  {
    fieldName  : FieldNames.financialStatementJointAccount,
    isOptional : false,
    label      : 'Is this held jointly',
    type       : DynamicFormFieldArrayType.Y_N_SWITCH_TOGGLE,
  },
];

const stockProps: DynamicFormFieldArray = {
  addButtonText : 'Account',
  initialValue  : stocksInitialValue,
  inputs        : stockInputs,
};

export const StocksFFAComponent = ({ ...props }) => {
  const { name, options } = props;
  const { t }    = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = { name }
        props     = { { dynamicProps: stockProps, name, t, options } }
        validate  = {[
          requiredArray([]),
        ]}
      />
    </FormControl>
  );
};
